import React from "react";
import { useFormContext, useController } from "react-hook-form";
// import { useSelector } from "react-redux";
import "./custom.scss";
const CustomRadioButton = (props) => {
  // 
  //   const viewOnlyFlag = useSelector((state) => state.formSubmit.viewOnlyFlag);
  const required = props.notRequired === undefined ? true : !props.notRequired;
  const handleOnChange = props?.handleOnChange || function () {};
  const onClick = typeof props.onClick === 'function' ? props.onClick : function () {};  // safe default
  //const selectedValue=props.selectedValue||0;
  const { name } = props.register;
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: "",
  });
  const randomIdYesBtn = Math.floor(1000000000 + Math.random() * 9000000000)
  const randomIdNoBtn = Math.floor(1000000000 + Math.random() * 8000000000)
  return (
    <>
      <div className="i-a-block">
        <h5 className={`${error !== undefined && "text-danger"}`}>
          {props.label} {required && <span className="red">*</span>}
        </h5>
        <div className="d-flex">
          <div>
            <input
              type="radio"
              disabled={props.disable || false}
              id={`${name}yes_${randomIdYesBtn}`}
              {...field}
              checked={String(field.value ?? "").toLowerCase() === "yes"}
              value="Yes"
              className="is-hidden"
              onChange={(e) => {
                field.onChange(e);
                handleOnChange();
              }}
            />
            <label
              htmlFor={`${name}yes_${randomIdYesBtn}`}
              className={`ms-1 btn1 btn1--yes ${
                required && !field.value && "backgroundCRD"
              } ${error !== undefined && "backgroundCRD"}`}
            >
              Yes
            </label>
          </div>
          <div
            onClick={onClick}
          >
            <input
              type="radio"
              id={`${name}no_${randomIdNoBtn}`}
              disabled={props.disable || false}
              checked={String(field.value ?? "").toLowerCase() === "no"}
              {...field}
              value="No"
              className="is-hidden"
              onChange={(e) => {
                field.onChange(e);
                handleOnChange();
              }}
            />
            <label
              htmlFor={`${name}no_${randomIdNoBtn}`}
              className={`ms-1 btn1 btn1--no 
            ${required && !field.value && "backgroundCRD"}
            
            ${error !== undefined && "backgroundCRD"}`}
            >
              No
            </label>
          </div>
        </div>
      </div>
      <div className="invalid-feedback" style={{ display: "block" }}>
        {" "}
        {error && error.message}
      </div>
    </>
  );
};

export default CustomRadioButton;
